import { Flex } from "@radix-ui/themes";
import { t } from "i18next";
import React, { Dispatch, SetStateAction } from "react";
import SortingCategory from "../../../components/Filters/SortingCategory";
import { Button } from "../../../ui/Button";
import { Popover, PopoverTrigger, PopoverContent } from "../../../ui/Popover";

export type MaintenancesSortingType = {
  date: undefined | boolean;
  time: undefined | boolean;
};

type Props = {
  sortingState: [MaintenancesSortingType, Dispatch<SetStateAction<MaintenancesSortingType>>];
};

const MaintenanceSorting = ({ sortingState }: Props) => {
  const [sorting, setSorting] = sortingState; // Общий фильтр
  const [timeSorting, setTimeSorting] = React.useState(sorting.time); // Подфильтры категорий
  const [dateSorting, setDateSorting] = React.useState(sorting.date);

  const sortByTime = (sortingValue: boolean) => {
    setDateSorting(undefined);
    setSorting({
      time: sortingValue,
      date: undefined,
    });
  };

  const sortByDate = (sortingValue: boolean) => {
    setTimeSorting(undefined);
    setSorting({
      time: undefined,
      date: sortingValue,
    });
  };

  const cleanSorting = () => {
    setDateSorting(undefined);
    setTimeSorting(undefined);
    setSorting({
      time: undefined,
      date: undefined,
    });
  };

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="xs">
          {t("sorting")}
        </Button>
      </PopoverTrigger>
      <PopoverContent style={{ width: 320 }} align={"start"}>
        <div>{t("sorting")}</div>
        <Flex direction={"column"} gap="3">
          <SortingCategory
            categoryName={t("time")}
            sortingState={[timeSorting, setTimeSorting]}
            changeSortingState={sortByTime}
          />
          <SortingCategory
            categoryName={t("date")}
            sortingState={[dateSorting, setDateSorting]}
            changeSortingState={sortByDate}
          />
          <Button variant="outline" size="xs" onClick={cleanSorting}>
            {t("clear")}
          </Button>
        </Flex>
      </PopoverContent>
    </Popover>
  );
};

export default MaintenanceSorting;
